const PrepTaskDetail = () => import('@/pages/lab/preptask/PrepTaskDetail');
const PrepTaskEdit = () => import('@/pages/lab/preptask/PrepTaskEdit');

export class PrepTaskRoutes {
  constructor() {
    this.route_root = 'prep-tasks/';
    this.type_single = 'Prep Task';
    this.type_plural = 'Prep Tasks';

    this.routes = [
      {
        path: `${this.route_root}/:prep_task_id`,
        name: `View ${this.type_single}`,
        component: PrepTaskDetail,
        meta: {requiresAuth: true}
      },
      {
        path: `${this.route_root}/:prep_task_id/edit`,
        name: `Update ${this.type_single}`,
        component: PrepTaskEdit,
        meta: {requiresAuth: true}
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}

